import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants, miniCardHeight, miniCardWidth } from '../../../modules/utils/constants/constants';

export const StyledSearchMiniCardSlider = styled.div<{
  containerWidth: number;
  miniCardLength: number;
}>`
  width: 100%;
  position: absolute;
  bottom: ${toRem(70)};
  z-index: 10;
  right: 0;
  left: 0;

  @media ${baseVariables.mediaQuery.md} {
    position: initial;
  }

  .carousel-container {
    ${props =>
      props?.miniCardLength * miniCardWidth + 48 <= props?.containerWidth - 32 &&
      `
   width: ${toRem(props?.miniCardLength * miniCardWidth + 48)};
  `}

    ${props =>
      props?.miniCardLength * miniCardWidth + 48 > props?.containerWidth - 32 &&
      `
   width: ${toRem(props?.containerWidth - 32)};
  `}
    overflow: hidden;
  }

  .carousel__slider-tray {
    ${props =>
      props?.miniCardLength * miniCardWidth + 48 <= props?.containerWidth - 32 &&
      `
   width: 100% !important;
  `}

    ${props =>
      props?.miniCardLength * miniCardWidth + 48 > props?.containerWidth - 32 &&
      `
   width: unset;
  `}
  }

  .search-mini-card {
    border-radius: ${toRem(14)};
  }

  .minicard__image {
    border-radius: ${toRem(14)} 0 0 ${toRem(14)};

    /* ${rtl`
      // &:is(${constants.RTL_LANG_LIST}) {
        // border-radius: 0 ${toRem(14)} ${toRem(14)} 0;
      // }
    `} */
  }

  .carousel-slider {
    width: 100%;
    min-height: ${toRem(miniCardHeight)};
    box-sizing: border-box;
    .carousel__inner-slide {
      .carousel__slide-focus-ring {
        outline-style: none;
      }
    }
  }

  .slide-container {
    width: ${toRem(miniCardWidth)};
    height: ${toRem(miniCardHeight)};
  }

  .carousel-provider {
      direction: ltr:

      /* ${rtl`
          // &:is(${constants.RTL_LANG_LIST}) {
            // direction: rtl:
        // }
      `} */
  }
`;
